import React from 'react';

const UserControlPanelSection = ({ settings, setSettings }) => (
  <div style={{
    padding: 20,
    background: 'linear-gradient(135deg, rgba(252, 211, 77, 0.15), rgba(253, 230, 138, 0.15))',
    borderRadius: 12,
    border: '1px solid rgba(252, 211, 77, 0.3)'
  }}>
    <h3 style={{ color: '#047857', margin: '0 0 20px 0', display: 'flex', alignItems: 'center', gap: 10 }}>
      <i className="fas fa-sliders-h" style={{ fontSize: '1.1rem' }} />
      User Control Panel
    </h3>
    
    {/* Setting 1: Rename Ultimate Search Page */}
    <div style={{ marginBottom: 18 }}>
      <label style={{ color: '#047857', fontWeight: 600, fontSize: '0.9rem', display: 'block', marginBottom: 8 }}>
        <i className="fas fa-pen" style={{ marginRight: 6, fontSize: '0.8rem' }} /> Ultimate Search Page Title
      </label>
      <input type="text" value={settings.ultimate_search_title}
        onChange={(e) => setSettings({ ...settings, ultimate_search_title: e.target.value })}
        placeholder="My Custom Search Page" className="input" style={{ maxWidth: 350 }}
        data-testid="ultimate-search-title-input" />
      <p style={{ fontSize: '0.75rem', color: '#71717a', marginTop: 5 }}>
        Customize the title displayed on your Ultimate Search page
      </p>
    </div>
    
    {/* Setting 2: Default Data Source */}
    <div style={{ marginBottom: 18 }}>
      <label style={{ color: '#047857', fontWeight: 600, fontSize: '0.9rem', display: 'block', marginBottom: 8 }}>
        <i className="fas fa-globe" style={{ marginRight: 6, fontSize: '0.8rem' }} /> Default Data Source
      </label>
      <div style={{ display: 'flex', gap: 12 }}>
        {[
          { value: 'personal', icon: 'fa-user', label: 'Personal Database', color: '#10b981' },
          { value: 'worldwide', icon: 'fa-globe-americas', label: 'Worldwide Database', color: '#3b82f6' }
        ].map(ds => (
          <label key={ds.value} style={{
            display: 'flex', alignItems: 'center', gap: 8, padding: '10px 16px', borderRadius: 8, cursor: 'pointer',
            background: settings.default_data_source === ds.value ? `rgba(${ds.color === '#10b981' ? '16,185,129' : '59,130,246'},0.2)` : '#475569',
            border: settings.default_data_source === ds.value ? `2px solid ${ds.color}` : '1px solid rgba(255,255,255,0.1)'
          }} data-testid={`data-source-${ds.value}`}>
            <input type="radio" name="default_data_source" value={ds.value}
              checked={settings.default_data_source === ds.value}
              onChange={(e) => setSettings({ ...settings, default_data_source: e.target.value })}
              style={{ accentColor: ds.color }} />
            <span style={{ color: settings.default_data_source === ds.value ? ds.color : '#a1a1aa' }}>
              <i className={`fas ${ds.icon}`} style={{ marginRight: 4 }} /> {ds.label}
            </span>
          </label>
        ))}
      </div>
      <p style={{ fontSize: '0.75rem', color: '#71717a', marginTop: 5 }}>
        Choose which database to show by default on map screens
      </p>
    </div>
    
    {/* Toggle Settings */}
    {[
      { key: 'auto_refresh_map', icon: 'fa-sync-alt', label: 'Auto-Refresh Map Data', desc: 'Automatically update map markers when filters change', color: '16,185,129' },
      { key: 'show_map_by_default', icon: 'fa-map-marked-alt', label: 'Show Map by Default', desc: 'Display the map panel automatically when loading pages', color: '59,130,246' },
      { key: 'compact_sidebar', icon: 'fa-compress-alt', label: 'Compact Sidebar Mode', desc: 'Use icons only in sidebar for more screen space', color: '245,158,11' },
      { key: 'notification_sounds', icon: 'fa-bell', label: 'Notification Sounds', desc: 'Play sounds for search completions and alerts', color: '236,72,153' }
    ].map(toggle => (
      <div key={toggle.key} style={{
        padding: '12px 15px',
        background: settings[toggle.key] ? `rgba(${toggle.color},0.1)` : 'rgba(255, 255, 255,0.4)',
        borderRadius: 10, marginBottom: 12,
        border: settings[toggle.key] ? `1px solid rgba(${toggle.color},0.3)` : '1px solid rgba(255, 255, 255, 0.85)'
      }}>
        <label style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', cursor: 'pointer' }}>
          <div style={{ display: 'flex', alignItems: 'center', gap: 10 }}>
            <i className={`fas ${toggle.icon}`} style={{ fontSize: '1.1rem', color: `rgba(${toggle.color},0.8)` }} />
            <div>
              <span style={{ color: '#334155', fontWeight: 600 }}>{toggle.label}</span>
              <p style={{ fontSize: '0.75rem', color: '#71717a', margin: '4px 0 0 0' }}>{toggle.desc}</p>
            </div>
          </div>
          <input type="checkbox" checked={settings[toggle.key]}
            onChange={(e) => setSettings({ ...settings, [toggle.key]: e.target.checked })}
            style={{ width: 20, height: 20, accentColor: `rgb(${toggle.color})` }}
            data-testid={`${toggle.key.replace(/_/g, '-')}-toggle`} />
        </label>
      </div>
    ))}
    
    {/* Setting 6: Dark Mode Intensity */}
    <div style={{ marginBottom: 12 }}>
      <label style={{ color: '#047857', fontWeight: 600, fontSize: '0.9rem', display: 'block', marginBottom: 8 }}>
        <i className="fas fa-moon" style={{ marginRight: 6, fontSize: '0.8rem' }} /> Dark Mode Intensity
      </label>
      <div style={{ display: 'flex', gap: 10 }}>
        {['light', 'normal', 'deep', 'oled'].map(intensity => (
          <label key={intensity} style={{
            flex: 1, padding: '10px 12px', borderRadius: 8, cursor: 'pointer', textAlign: 'center',
            background: settings.dark_mode_intensity === intensity ? 'rgba(252, 211, 77,0.3)' : '#475569',
            border: settings.dark_mode_intensity === intensity ? '2px solid #FCD34D' : '1px solid rgba(255,255,255,0.1)'
          }} data-testid={`dark-mode-${intensity}`}>
            <input type="radio" name="dark_mode_intensity" value={intensity}
              checked={settings.dark_mode_intensity === intensity}
              onChange={(e) => setSettings({ ...settings, dark_mode_intensity: e.target.value })}
              style={{ display: 'none' }} />
            <span style={{
              color: settings.dark_mode_intensity === intensity ? '#047857' : '#71717a',
              fontSize: '0.85rem', fontWeight: settings.dark_mode_intensity === intensity ? 600 : 400, textTransform: 'capitalize'
            }}>{intensity}</span>
          </label>
        ))}
      </div>
    </div>
  </div>
);

export default UserControlPanelSection;
